<template>
    <div class="environment-badge" :class="environment" v-if="environment">
        <span class="label">
            <i class="icon exclamation-mark"></i> {{ environment }}
        </span>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class EnvironmentBadge extends Vue {
        @Prop({type: String, required: false}) public environment?: string;
    }
</script>

<style lang="scss" scoped>
    .environment-badge {
        height: 1rem;
        position: absolute;
        z-index: 10;
        width: 10rem;
        left: 0.8rem;
        border-radius: 0 0 7px 7px;
        display: flex;
        justify-content: center;
        box-shadow: var(--environment-badge-shadow);
        color: var(--main-background-color);

        .icon {
            background: var(--main-background-color);
            vertical-align: -1px;
        }

        .label {
            display: inline-block;
            font-size: .75rem;
            line-height: 1rem;
            font-weight: bold;
        }

        &.local,
        &.config,
        &.develop {
            background: var(--environment-development);
        }

        &.clone,
        &.featuretest,
        &.test {
            background: var(--environment-test-background);
            color: var(--environment-test-color);
        }

        &.acceptance {
            background: var(--environment-acceptance);
        }

        &.production {
            background: var(--environment-production);
        }

    }
</style>
